export default __webpack_public_path__ + "static/media/img1.7759c422.jpg";